import { deleteField, doc, getDoc, serverTimestamp, writeBatch } from "firebase/firestore";
import { deleteObject, getBytes, getDownloadURL, listAll, ref, uploadBytes } from "firebase/storage";
import { _cacheGroupTypes } from "global/cnr/contexts/useHelpers/useTimestamp";
import { logBatch } from "global/cnr/reducers/reducerHelpers/logging";
import { fs_dbu } from "global/firestoreData/appData/fsAppDataUpdate";
import { dispatchProps } from '../../../cnr/reducers/reducerHelpers/dispatchProps';
import { dataFix } from "../../../common/dataFix";
import { gEnums } from "../../../enums/globalEnums";
import { createRefPath, createRefPath_client, createRefPath_event } from '../../appData/appRefPaths';
import { _profileCollectionName } from "../../profiles/getProfile";

const _allowUpdate = true

const _localRestriction = false
const _updateRelations = true
const allowTimestamps = true

export const fsUpdate_updateDoc = async (props) => {

  const {
    appUser,
    baseRef,
    dispatch,
    opts,
    pathViews,
    ufProps,
    appSettings_fns,
    database_fns,
    fn_cls,
    mainDb,
  } = props

  const { refPath, refPaths, directCollection } = baseRef

  let {
    appDataDocs,
    appDataSource,
    dataRestrictions,
    relatedDocsToUpdate,
    itemData,
    data_original,
    storagePaths,
    mainStorage,
    swipedItem,
    useTimestamps,
    viDeps,
    viewKey,
    vit,
  } = ufProps ?? {}

  const { update_timestamp } = fs_dbu(mainDb)

  const { appDataSourceType, useAppDataDocuments, updateAppDataDocuments, autoUpdateCollectionRelationships } = appDataSource ?? {}
  let _updateAppDataDocuments = updateAppDataDocuments || useAppDataDocuments

  switch (appDataSourceType) {
    case gEnums.dataSourceTypes.firebase:
      // case gEnums.dataSourceTypes.firebaseDocument:
      _updateAppDataDocuments = true
      break;
    default:
    // nothing
  }

  let _refPath = [...refPaths]

  if (!viewKey && itemData && itemData.id) { viewKey = itemData.id }
  if (!viewKey && itemData && itemData._itemKey) { viewKey = itemData._itemKey }
  if (!viewKey && swipedItem && swipedItem.key) { viewKey = swipedItem.key }

  // const callback_test = (results) => {
  //   if (opts && opts.settingsProps) {
  //     appSettings_fns.createNewViewAndViewItemsSettingsDB(opts.settingsProps, pathViews).then(
  //       dispatch && dispatch({ type: dispatchProps.success, dispatch })
  //     )
  //   }
  //   dispatch && dispatch({ ...results, dispatch })
  // }


  if (viewKey) {

    const _collectionName = directCollection ? directCollection : vit

    let dataToUpdate;
    let mergeData = false
    let _editRef = refPath

    const { documentDependencies } = viDeps
    if (documentDependencies && documentDependencies.length > 0 && Object.keys(pathViews).length > 0) {
      // loop the depenedents 
      documentDependencies.forEach(viewItemDep => {
        const docDepKey = pathViews[viewItemDep]
        if (docDepKey) {
          _editRef = createRefPath([viewItemDep, docDepKey], _editRef)
          dataToUpdate = {
            [_collectionName]: {
              [itemData.id]: { ...itemData }
            }
          }
          mergeData = true
        }
      })
    } else {
      if (_.includes(_editRef, _collectionName)) {
        // nothing. let it go
      } else {
        _editRef = createRefPath([_collectionName, viewKey], _editRef)
      }
      dataToUpdate = itemData
    }

    // if (_localRestriction || (dataRestrictions && (dataRestrictions.all || dataRestrictions.editData))) {
    //   // const sheetName = _.startCase('Health And Safety')
    //   // fsfn_updateSheetRangeValues('17mlSzJXO-EqfjdDdFyzkclmilhjnufDLw_q7qmFNkX4', sheetName, 0, { name: 'Test' })
    //   callback_test({ type: dispatchProps.successAlt, dispatch })
    //   return false
    // }

    getDocItemData(database_fns, pathViews, vit, viewKey, dataToUpdate, autoUpdateCollectionRelationships).then(async existingItem => {

      dataToUpdate = dataFix.removeAllEmpties(dataToUpdate, true)
      // dataToUpdate = dataFix.createDeleteFields(dataToUpdate)
      dataToUpdate = dataFix.removePrivateProps(dataToUpdate, ['methodName', 'id'])
      dataToUpdate = dataFix.removeAllEmpties(dataToUpdate)

      if (useTimestamps) {
        dataToUpdate._ts = {
          _updateDate: serverTimestamp(),
          _uid: appUser.uid,
          _user: appUser.displayName
        }
      }

      // handles the callback from the document update
      const callback_edit = (results) => {

        dispatch && dispatch({ ...results, dispatch })
      }

      switch (vit) {
        case 'videoConference':
          _refPath = createRefPath_client(pathViews, [_profileCollectionName, viewKey])
          delete itemData.id
          database_fns.update_doc(_refPath, itemData, callback_edit)
          break;

        default:
          if (mergeData) {
            database_fns.set_doc(_editRef, dataToUpdate, true).then(res => {
              const editPath = _collectionName + '/' + viewKey
              switch (vit) {
                case 'profiles':
                  fn_cls.addAuthCustomToken(dataToUpdate, dispatchProps.success)
                  break;
                default:
                  callback_edit({ type: dispatchProps.success, updatePath: editPath })
              }
            }).catch(err => {
              dispatch && dispatch({ type: dispatchProps.error, err })
            });
          } else {
            try {
              // update the document in firebase
              // console.log('_editRef', _editRef, dataToUpdate) 

              const emailChanged =
                _.has(data_original, 'email') &&
                _.has(dataToUpdate, 'email') &&
                _.toLower(_.trim(_.get(data_original, 'email', ''))) !==
                _.toLower(_.trim(_.get(dataToUpdate, 'email', '')));

              if (emailChanged) {
                console.log('emailChanged', data_original?.email, dataToUpdate?.email, dataToUpdate)
              } else {
                console.log('email NOT Changed', dataToUpdate)
              }

              // start the batch
              const batchInfos = []
              const batch = writeBatch(mainDb);

              ammendBatch_docsToUpdate(batch, mainDb, pathViews, _editRef, viewKey, _collectionName, dataToUpdate, batchInfos)

              if (relatedDocsToUpdate) {
                await ammendBatch_relatedDocsToUpdate(batch, mainDb, pathViews, relatedDocsToUpdate, batchInfos)
              }

              if (emailChanged && 1 === 3) {
                await ammendBatch_emailDocs(batch, mainDb, pathViews, dataToUpdate, data_original, batchInfos)
                await ammendProfileStorage(mainStorage, database_fns, pathViews, dataToUpdate, data_original)
              }

              // const ref_path_ts = createRefPath(['_timeStamps', 'ts'])
              // const doc_ts = doc(mainDb, ref_path_ts)
              // const tsToUpdate = {
              //   ['eventInfo']: {
              //     [pathViews.events]: Date.now()
              //   }
              // }
              const _timestamp = Date.now()
              update_timestamp(_cacheGroupTypes.eventInfo, pathViews.events, _timestamp, batch)

              // batch.set(doc_ts, tsToUpdate, { merge: true })
              // batchInfos.push({ refPath: ref_path_ts, dataToUpdate: tsToUpdate })

              // console.log('💾💾💾 batchInfos', batchInfos)

              if (_allowUpdate) {
                await batch.commit()
              }

              logBatch(batch)

              dispatch && dispatch({ type: dispatchProps.success, dispatch })
            } catch (error) {
              console.log('ERROR', error)
              console.log('dataToUpdate', dataToUpdate)
              dispatch && dispatch({ type: dispatchProps.error, error })
            }
          }
      }
    })
  } else {
    alert('Item not updated. No viewItemKey')
  }
}

const getDataArrayToUpdate = (data) => {
  const dataToUpdate = _.mapValues(_.pickBy(data, _.isArray), (arr) => [...arr]); // Modify arrays if needed
  return dataToUpdate
}

const getDocItemData = async (database_fns, pathViews, vit, itemKey, dataToUpdate, autoUpdateCollectionRelationships) => {
  if (_updateRelations && autoUpdateCollectionRelationships) {
    const _refPath_existing = createRefPath_event(pathViews, [vit, itemKey])
    const existingItem = await database_fns.get_data({ refPath: _refPath_existing, opts: { returnFirstObject: true } })
    return existingItem
  } else {
    return dataToUpdate
  }
}

const ammendBatch_docsToUpdate = async (batch, mainDb, pathViews, _editRef, viewKey, _collectionName, dataToUpdate, batchInfos) => {
  // primary doc
  const doc_primary = doc(mainDb, _editRef)
  batch.set(doc_primary, dataToUpdate, { merge: true })
  batchInfos.push({ refPath: _editRef, dataToUpdate })

  // _document doc
  const baseRef = createRefPath_event(pathViews)
  const _refPathDoc = createRefPath(['_documents', _collectionName], baseRef)
  const doc_docs = doc(mainDb, _refPathDoc)

  const docToUpdate = { [viewKey]: dataToUpdate }
  batch.set(doc_docs, docToUpdate, { merge: true })
  batchInfos.push({ refPath: _refPathDoc, dataToUpdate: docToUpdate })
}

const ammendBatch_relatedDocsToUpdate = async (batch, mainDb, pathViews, relatedDocsToUpdate, batchInfos) => {
  const promises = []
  const baseRef = createRefPath_event(pathViews)
  _.forEach(relatedDocsToUpdate, (docItemsToUpdate, docCollectionKey) => {
    const docToUpdate = {}
    const _refPathDoc = createRefPath(['_documents', docCollectionKey], baseRef)
    _.forEach(docItemsToUpdate, (docItemToUpdate, docKey) => {
      const refPath = createRefPath_event(pathViews, [docCollectionKey, docKey])
      docToUpdate[docKey] = docItemToUpdate
      if (batch) {
        const xxx = doc(mainDb, refPath)
        batch.set(xxx, docItemToUpdate, { merge: true })
        batchInfos.push({ refPath: refPath, dataToUpdate: docItemToUpdate })
        // batch.update(refPath, docItemToUpdate)
      }
    })
    if (batch) {
      const xxx = doc(mainDb, _refPathDoc)
      batch.set(xxx, docToUpdate, { merge: true })
      batchInfos.push({ refPath: _refPathDoc, dataToUpdate: docToUpdate })
    }
  })
  return Promise.all(promises)
}

const ammendBatch_emailDocs = async (batch, mainDb, pathViews, dataToUpdate, data_original, batchInfos) => {

  const ref_path_old = createRefPath_client(pathViews, ['profiles', data_original.email]);
  const ref_path_new = createRefPath_client(pathViews, ['profiles', dataToUpdate.email]);

  const profileDocRefOld = doc(mainDb, ref_path_old);
  const profileDocRefNew = doc(mainDb, ref_path_new);

  // --- Get the existing doc ---
  const oldSnap = await getDoc(profileDocRefOld);

  if (oldSnap.exists()) {

    const oldData = oldSnap.data();

    // --- Build the new doc data ---
    const newData = {
      ...oldData,   // keep everything that already exists
      email: dataToUpdate.email,
    };

    // --- Batch operations ---
    batch.set(profileDocRefNew, newData);   // full overwrite on new doc
    batch.delete(profileDocRefOld);         // remove old doc

    batchInfos.push({ refPath: ref_path_new, dataToUpdate: newData })
    batchInfos.push({ refPath: ref_path_old, dataToDelete: true })

  }

  const ref_path_gallery = createRefPath_client(pathViews, ['profileGallery', 'galleryItems'])
  const galleryDoc = doc(mainDb, ref_path_gallery);

  const gallerySnap = await getDoc(galleryDoc);

  if (gallerySnap.exists()) {
    const galleryData = gallerySnap.data() || {};
    const galleryDataItem = galleryData[data_original.email]
    if (galleryDataItem) {
      const galleryToUpdate = {
        [dataToUpdate.email]: galleryData[data_original.email], // add new key
        [data_original.email]: deleteField() // remove old key
      }
      batch.set(
        galleryDoc,
        galleryToUpdate,
        { merge: true }
      );
      batchInfos.push({ refPath: ref_path_gallery, dataToUpdate: galleryToUpdate })
    }
  }

}

const ammendProfileStorage = async (mainStorage, database_fns, pathViews, dataToUpdate, data_original) => {

  const { clients } = pathViews
  const { email: originalEmail } = data_original ?? {}
  const { email: newEmail } = dataToUpdate ?? {}

  const oldFolderRef = ref(mainStorage, `clients/${clients}/profiles/${originalEmail}`);
  const newFolderPath = `clients/${clients}/profiles/${newEmail}`;

  const listResult = await listAll(oldFolderRef);
  const uploadedItems = []
  let url = ''

  for (const fileRef of listResult.items) {
    const newFileRef = ref(mainStorage, `${newFolderPath}/${fileRef.name}`);

    if (_allowUpdate) {
      // 1️⃣ Get the bytes from the old file
      const fileBytes = await getBytes(fileRef);

      // 2️⃣ Upload to the new location
      const uploadResult = await uploadBytes(newFileRef, fileBytes);

      // 3️⃣ Get the download URL of the uploaded filep
      url = await getDownloadURL(uploadResult.ref);
    } else {
      url = await getDownloadURL(fileRef);
    }

    uploadedItems.push({
      fileKey: fileRef.name,
      fileName: fileRef.name,
      url
    });

    if (_allowUpdate) {
      // 4️⃣ Delete the old file
      await deleteObject(fileRef);
    }

  }

  const metadata = {
    customMetadata: {
      uploadedBy: 'admin',
    },
  };

  ammendDatabase_assetUrls(pathViews.events, gEnums.fileOptionTypes.clientProfile, uploadedItems, metadata, database_fns)

}

const ammendDatabase_assetUrls = async (eventKey, fileOptionType, uploadedItems, metadata, database_fns) => {
  const _timestamp = Date.now();
  const dataToUpdate = {};
  const _dataToUpdate = {};
  let refPath = null;
  let refPath_ts = null;
  let _cacheGroupType = _cacheGroupTypes.urls;
  let useDash = false;

  if (uploadedItems?.length === 0) { return; }

  const ensureNested = (obj, key) => {
    if (!obj[key]) obj[key] = { ...metadata, urls: {} };
    if (!obj[key].urls) obj[key].urls = {};
    return obj[key];
  };

  for (const uploadedItem of uploadedItems) {
    const { fullPath, url } = uploadedItem;
    const fps = fullPath.split('/');

    // Named indices for readability
    const clientRoot = fps[0];    // 'client'
    const clientKey = fps[1];      // 'clientKey'
    const eventRoot = fps[2];    // 'event' or folder type
    // const eventKey = fps[3]; // 'eventKey'

    if (fileOptionType === gEnums.fileOptionTypes.clientProfile) {
      const profileKey = fps[3];   // use eventKeyFromPath as profile key?
      const fileName = fps[4];

      refPath = `${clientRoot}/${clientKey}/profileGallery/galleryItems/`;

      const item = ensureNested(dataToUpdate, profileKey);
      const itemDash = ensureNested(_dataToUpdate, profileKey);

      item.urls[fileName] = url;
      itemDash.urls[fileName] = url;

      useDash = true;
      _cacheGroupType = _cacheGroupTypes.appUsersInfo;

    } else {
      // default case
      // eventKey = eventKey; // overwrite the eventKey
      const assetFolder = fps[4];
      const entityKey = fps[5];   // e.g., teamId or other key
      const fileBase = stripImageSuffix(fps[6]);
      const fileProp = fps[7];    // property to store under

      refPath = `${clientRoot}/${clientKey}/${eventRoot}/${eventKey}/_assetUrls/${assetFolder}/`;
      refPath_ts = `${clientRoot}/${clientKey}/${eventRoot}/${eventKey}/_assetUrls/_timestamp/`;

      const keyDot = `${entityKey}.${fileBase}.${fileProp}`;
      const keyUnderscore = `${entityKey}_${fileBase}_${fileProp}`;

      dataToUpdate[keyDot] = url;
      _dataToUpdate[keyUnderscore] = url;
    }
  }

  const nestedData = useDash
    ? expandDotNotationWithFileFix(_dataToUpdate, '_')
    : expandDotNotationWithFileFix(dataToUpdate);

  const dataTs = { timestamp: _timestamp };

  console.log('refPath', refPath, nestedData)
  console.log('refPath_ts', refPath_ts, dataTs)
  console.log('_cacheGroupType', _cacheGroupType, eventKey, _timestamp)

  return;


};

function expandDotNotationWithFileFix(obj, splitChar) {
  const result = {};
  for (const key in obj) {
    const parts = key.split(splitChar ? splitChar : '.');

    // Detect if the first part contains an image extension
    if (parts.length > 1) {
      parts[0] = stripImageSuffix(parts[0]);
    }

    let current = result;
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      if (i === parts.length - 1) {
        current[part] = obj[key];
      } else {
        current[part] = current[part] || {};
        current = current[part];
      }
    }
  }
  return result;
}
